module.exports = __webpack_public_path__ + "img/symbol_13_normal.eb2d9f6d.png";